import React from "react";
import { Redirect } from "react-router";
import Context from "../../../Context";
import visualState from "../../../visualState";
import EssenceReference from "../../Essence/EssenceReference";
import Blocker from "../../Misc/Blocker";
import CartButton from "../../Misc/Cart/CartButton";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Scrollpane from "../../Misc/Scrollpane";
import ModelCategory from "./ModelCategory";
import ModelDetail from "./ModelDetail";
import ModelList from "./ModelList";

let searchTimeout = null;

export default class Model extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.vState = new visualState("modelSection");
    this.state = {
      redirect: false,
      pending: false,
      mode: props.mode,
      categoryId: props.categoryId,
      modelId: props.modelId,
      urlKey: `${this.props.mode}${this.props.categoryId}${this.props.modelId}`,
      customListKey: "",
      referenceShow: false,

      rights: {},

      categoryItems: [],
      categorySearch: [],
      categorySearchText: "",
      categorySearchPending: "",
      categorySearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "item.category",
          rstr: ")",
        },
      ],
    };
  }

  makeUrlKey() {
    return `${this.props.mode}${this.props.categoryId}${this.props.modelId}`;
  }

  componentDidMount() {
    this.loadStructure();
    this.load();
    this.assignRights();
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.mode !== prevProps.mode ||
      this.props.categoryId !== prevProps.categoryId ||
      this.props.modelId !== prevProps.modelId
    ) {
      this.setState(
        {
          mode: this.props.mode,
          categoryId: this.props.categoryId,
          modelId: this.props.modelId,
          urlKey: `${this.props.mode}${this.props.categoryId}${this.props.modelId}`,
          redirect: false,
        },
        () => this.load()
      );
    }
    this.renderButtons();
  }

  handleCategorySearch = (searchValue) => {
    this.setState({ categorySearchText: searchValue });
    this.setState({ categorySearchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let categorySearch = searchValue
        ? [
            {
              lstr: "(",
              field: "label",
              compare: "IKE",
              value: `%${searchValue}%`,
              rstr: ")",
            },
          ]
        : [];
      this.setState(
        {
          categorySearchPending: false,
          categorySearch,
        },
        () => this.loadStructure()
      );
    }, 1500);
  };

  assignRights = () => {
    this.setState(
      {
        rights: {
          manageModel: true,
          manageCategory: true,
        },
      },
      () => this.renderButtons()
    );
  };

  handleCategorySearchCancell = () => {
    window.clearTimeout(searchTimeout);
    this.setState(
      {
        categorySearchPending: false,
        categorySearchText: "",
        categorySearch: [],
      },
      () => this.loadStructure()
    );
  };

  pendingOn = () => {
    this.setState({ pending: true });
  };

  pendingOff = () => {
    this.setState({ pending: false });
  };

  referenceHide = () => {
    this.setState({ referenceShow: false });
    this.loadStructure();
  };

  referenceShow = () => {
    this.setState({ referenceShow: true });
  };

  renderButtons = () => {
    const { categoryId } = this.state;
    this.context.actionsSet(
      <>
        <a
          href={`/model/${categoryId}/add`}
          onClick={this.pendingOn}
          className={`btn ${
            this.state.mode === "add" ? "btn-light-primary" : "btn-light"
          } p-2  mr-2`}
        >
          <span className="flaticon2-add-1 px-2 align-middle"></span>
        </a>
        <CartButton context={this.context} />
      </>
    );
  };

  load = () => {};

  loadStructure = async () => {
    this.pendingOn();
    const search = this.state.categorySearchDefault.concat(
      this.state.categorySearch
    );
    let categoryItems = await this.context.api.qa(`/category/list`, {
      search,
    });
    this.setState({ categoryItems });
    this.pendingOff();
  };

  onAfterModelSave = (item = {}) => {
    this.setState({ customListKey: this.context.key() });
  };

  onAfterModelAdd = (item = {}) => {
    const { id } = item;
    const { categoryId } = this.props;
    if (id) {
      this.setState({ redirect: `/model/${categoryId}/${id}/` });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const showCategoryManage =
      !this.state.pending && this.state.rights.manageCategory;
    return (
      <>
        <CrumbsProvider title="Параметры" link="/reference/" />
        <CrumbsProvider title="ЗИП" />
        {this.state.referenceShow && (
          <EssenceReference
            essence="category"
            sort="sequence"
            title="Категории"
            showDescription
            editOnDblClick
            show={true}
            onHide={() => this.referenceHide()}
            forceType="item.category"
          />
        )}
        <Blocker on={this.state.pending}>
          <div className="row h-100">
            <div className="col-lg-3 border-right no-print">
              <Scrollpane>
                <div className="d-flex mb-4">
                  <div className="text-nowrap flex-grow-1 mr-2">
                    <div className="input-group">
                      <input
                        className="form-control form-control-solid d-inline-block w-auto"
                        type="text"
                        placeholder="Поиск категории..."
                        value={this.state.categorySearchText || ""}
                        onChange={(e) =>
                          this.handleCategorySearch(e.target.value)
                        }
                      />

                      {this.state.categorySearchText &&
                      !this.state.categorySearchPending ? (
                        <div className="input-group-append">
                          <button
                            title="Отменить поиск"
                            className="btn btn-icon btn-secondary"
                            type="button"
                            onClick={() => this.handleCategorySearchCancell()}
                          >
                            <i className="fa text-muted fa-close"></i>
                          </button>
                        </div>
                      ) : (
                        <>
                          {showCategoryManage && (
                            <div className="input-group-append">
                              <button
                                title="Настройка категорий"
                                className="btn btn-icon btn-secondary"
                                type="button"
                                onClick={() => this.referenceShow()}
                              >
                                <i className="fa text-muted fa-cogs"></i>
                              </button>
                            </div>
                          )}
                        </>
                      )}
                      {this.state.categorySearchPending ? (
                        <div className="input-group-append">
                          <div className="btn btn-icon btn-light">
                            <div className="spinner mr-5"></div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <ModelCategory
                  mode={this.state.mode}
                  categoryId={this.state.categoryId}
                  modelId={this.state.modelId}
                  categoryItems={this.state.categoryItems}
                />
              </Scrollpane>
            </div>
            <div className="col-lg-3 no-print border-right">
              <Scrollpane>
                <ModelList
                  listKey={this.state.customListKey}
                  mode={this.state.mode}
                  categoryId={this.state.categoryId}
                  modelId={this.state.modelId}
                  categoryItems={this.state.categoryItems}
                />
              </Scrollpane>
            </div>
            <div className="col h-100">
              <Scrollpane>
                {this.state.modelId && (
                  <ModelDetail
                    mode={this.state.mode}
                    categoryId={this.state.categoryId}
                    modelId={this.state.modelId}
                    onAfterSave={this.onAfterModelSave}
                    onAfterAdd={this.onAfterModelAdd}
                    {...this.state.rights}
                  />
                )}
              </Scrollpane>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
